import { IPharmacyInfo } from "@/Common/Api/Pharmacy/Dto/Responses/IPharmacyInfo";
import { OverlayElement, OverlayElementType } from "./OverlayElement";

export class PrepositionedPharmacyInfoOverlayElement extends OverlayElement {
    public Pharmacy: IPharmacyInfo;
    public IsSetPreferred?: boolean;

    public constructor(init?: Partial<PrepositionedPharmacyInfoOverlayElement>, hidePharmacists?: boolean) {
        super(OverlayElementType.PrepositionedPharmacyInfo, init);
        Object.assign(this, init, { Pharmacy: { ...init?.Pharmacy } });
        if (hidePharmacists)
            this.Pharmacy.Name = null;
    }
}
